// Leaf module: intentionally free of imports so slices can use it without
// pulling in HelperFunctions, which imports back from the slices.
export const isColorDark = (colorCode: string) => {
  try {
    let r, g, b;
    if (colorCode.startsWith("#")) {
      const hex = colorCode.replace("#", "");
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else if (hex.length === 6) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
      } else {
        return false;
      }
    } else if (colorCode.startsWith("rgb")) {
      const rgbValues = colorCode
        .replace(/[^\d,]/g, "")
        .split(",")
        .map(Number);
      [r, g, b] = rgbValues;
    } else {
      return false;
    }
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
  } catch (error) {
    console.log("error =====", error);
    return false;
  }
};
